import { FieldType } from '@ngx-formly/material';

import { Component } from '@angular/core';

import { ISnDetailedCheckboxFormFieldConfig, ISnDetailedCheckboxTemplateOptions } from '../../..';

@Component({
  selector: 'fs-detailed-checkbox-form-field',
  templateUrl: './detailed-checkbox.form-field.html',
  styleUrls: ['./detailed-checkbox.form-field.scss'],
})
export class SnDetailedCheckboxFormField extends FieldType<ISnDetailedCheckboxFormFieldConfig> {
  public override readonly defaultOptions: ISnDetailedCheckboxFormFieldConfig = {
    type: 'detailed-checkbox',  
    templateOptions: {
      floatLabel: 'always',
      hideLabel: true,
      appearance: 'fill',
      color: 'accent',
      hideFieldUnderline: true,
    },
  };

  get templateOptions(): ISnDetailedCheckboxTemplateOptions {
    return this.field.templateOptions;
  }
}
